import React, { useState, useRef, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BulkActionsDropdown = ({ selectedJobs, onBulkAction }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const bulkActions = [
    { id: 'activate', label: 'Mark as Active', icon: 'Play', color: 'text-success' },
    { id: 'draft', label: 'Move to Draft', icon: 'Edit', color: 'text-warning' },
    { id: 'close', label: 'Close Postings', icon: 'X', color: 'text-muted-foreground' },
    { id: 'duplicate', label: 'Duplicate Selected', icon: 'Copy', color: 'text-primary' },
    { id: 'export', label: 'Export Data', icon: 'Download', color: 'text-primary' },
    { id: 'archive', label: 'Archive Selected', icon: 'Archive', color: 'text-error' }
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef?.current && !dropdownRef?.current?.contains(event?.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleAction = (actionId) => {
    onBulkAction(actionId, selectedJobs);
    setIsOpen(false);
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <Button
        variant="outline"
        iconName="MoreVertical"
        iconPosition="left"
        onClick={() => setIsOpen(!isOpen)}
        disabled={selectedJobs?.length === 0}
      >
        Bulk Actions ({selectedJobs?.length})
      </Button>
      {isOpen && (
        <div className="absolute top-full left-0 mt-2 w-56 bg-popover border border-border rounded-lg shadow-modal z-[100]">
          <div className="p-2">
            {bulkActions?.map((action) => (
              <button
                key={action?.id}
                onClick={() => handleAction(action?.id)}
                className={`w-full flex items-center space-x-3 px-3 py-2 text-left text-sm rounded-md hover:bg-muted transition-colors duration-150 ${action?.color}`}
              >
                <Icon name={action?.icon} size={16} />
                <span>{action?.label}</span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default BulkActionsDropdown;